import React from 'react';

import { TRecommendation } from '@/services/requests/Recommendation/types/template1';

type TProps = {
  data: TRecommendation;
};

export const Notes = React.memo(({ data }: TProps) => {
  return (
    <>
      {data.notes ? (
        <p className="vitrine-template1__notes">{data.notes}</p>
      ) : null}
    </>
  );
});
